import * as yup from 'yup'

const sanitizeNumber = (value: number) =>
  isNaN(value) || value === null || value === undefined ? null : value

const sanitizeString = (value: string) =>
  value === null || value === undefined ? null : value

export default yup.object().shape({
  name: yup.string().required('Campo obrigatório'),
  projectId: yup.number().nullable().required('Campo obrigatório'),
  administrativeUserEmail: yup.string().transform(sanitizeString).nullable().notRequired(),
  expertId: yup.number().transform(sanitizeNumber).nullable().notRequired(),
})
